// Do not change the order of items inside. The index value is used to sort user skus for reporting.
export var ConsumerSkuType;
(function (ConsumerSkuType) {
    ConsumerSkuType[ConsumerSkuType["O365Home"] = 0] = "O365Home";
    ConsumerSkuType[ConsumerSkuType["O365Personal"] = 1] = "O365Personal";
    ConsumerSkuType[ConsumerSkuType["O365Solo"] = 2] = "O365Solo";
    ConsumerSkuType[ConsumerSkuType["OtherSubscription"] = 3] = "OtherSubscription";
    ConsumerSkuType[ConsumerSkuType["Perpetual"] = 4] = "Perpetual";
    ConsumerSkuType[ConsumerSkuType["Perpetual2019"] = 5] = "Perpetual2019";
    ConsumerSkuType[ConsumerSkuType["O365HomeTrial"] = 6] = "O365HomeTrial";
    ConsumerSkuType[ConsumerSkuType["NonActive"] = 7] = "NonActive";
    ConsumerSkuType[ConsumerSkuType["NotSubscribed"] = 8] = "NotSubscribed";
    ConsumerSkuType[ConsumerSkuType["NotDetected"] = 9] = "NotDetected";
    ConsumerSkuType[ConsumerSkuType["O365Basic"] = 10] = "O365Basic";
})(ConsumerSkuType || (ConsumerSkuType = {}));
//# sourceMappingURL=ConsumerSkuType.js.map